const ITEMS_PER_PAGE = 2;
const STROKE_IDLE = "#0A1128";
const STROKE_DISABLED = "#69747A";
const STROKE_HOVER = "#0a1128";

function getItemWidth() {
	return window.innerWidth < 1140 ? 220 : 240;
}

function initFeaturesCarousel(block) {
	if (block.dataset.featuresInit === "true") {
		return;
	}

	const carousel = block.querySelector(".carousel-container");
	const items = carousel
		? Array.from(carousel.querySelectorAll(".carousel-item"))
		: [];

	if (!carousel || !items.length) {
		return;
	}

	block.dataset.featuresInit = "true";

	const prevButton = block.querySelector(".prev-button");
	const nextButton = block.querySelector(".next-button");
	const prevPath = prevButton ? prevButton.querySelector("path") : null;
	const nextPath = nextButton ? nextButton.querySelector("path") : null;
	const progressBar = block.querySelector(".progress");
	const totalItems = items.length;

	let currentIndex = 0;
	let itemWidth = getItemWidth();

	function updateCarousel() {
		const remainingItems = totalItems - currentIndex;
		const visibleItems = Math.min(remainingItems, ITEMS_PER_PAGE);

		let scrollDistance = currentIndex * itemWidth;
		if (currentIndex + ITEMS_PER_PAGE >= totalItems && totalItems % 2 !== 0) {
			scrollDistance = (totalItems - 1) * itemWidth;
		}

		carousel.scrollTo({
			left: scrollDistance,
			behavior: "smooth",
		});

		if (progressBar) {
			const progressPercentage = Math.min(
				((currentIndex + visibleItems) / totalItems) * 100,
				100,
			);
			progressBar.style.width = `${progressPercentage}%`;
		}

		if (prevButton && nextButton && prevPath && nextPath) {
			prevButton.disabled = currentIndex === 0;
			nextButton.disabled = currentIndex + ITEMS_PER_PAGE >= totalItems;

			prevPath.setAttribute(
				"stroke",
				currentIndex === 0 ? STROKE_DISABLED : STROKE_IDLE,
			);
			nextPath.setAttribute(
				"stroke",
				currentIndex + ITEMS_PER_PAGE >= totalItems
					? STROKE_DISABLED
					: STROKE_IDLE,
			);
		}
	}

	if (prevButton && nextButton) {
		prevButton.addEventListener("click", () => {
			if (currentIndex - ITEMS_PER_PAGE >= 0) {
				currentIndex -= ITEMS_PER_PAGE;
				updateCarousel();
			}
		});

		nextButton.addEventListener("click", () => {
			if (currentIndex + ITEMS_PER_PAGE < totalItems) {
				currentIndex += ITEMS_PER_PAGE;
				updateCarousel();
			}
		});

		if (prevPath) {
			prevButton.addEventListener("mouseenter", () => {
				if (!prevButton.disabled) {
					prevPath.setAttribute("stroke", STROKE_HOVER);
				}
			});
			prevButton.addEventListener("mouseleave", () => {
				if (!prevButton.disabled) {
					prevPath.setAttribute("stroke", STROKE_IDLE);
				}
			});
		}

		if (nextPath) {
			nextButton.addEventListener("mouseenter", () => {
				if (!nextButton.disabled) {
					nextPath.setAttribute("stroke", STROKE_HOVER);
				}
			});
			nextButton.addEventListener("mouseleave", () => {
				if (!nextButton.disabled) {
					nextPath.setAttribute("stroke", STROKE_IDLE);
				}
			});
		}
	}

	window.addEventListener("resize", () => {
		itemWidth = getItemWidth();
		updateCarousel();
	});

	updateCarousel();
}

function bootFeaturesCarousels() {
	document
		.querySelectorAll("[data-features]")
		.forEach((block) => initFeaturesCarousel(block));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootFeaturesCarousels);
} else {
	bootFeaturesCarousels();
}
